import { render, staticRenderFns } from "./ContentAttachments.vue?vue&type=template&id=7ca511a6&scoped=true"
import script from "./ContentAttachments.vue?vue&type=script&lang=js"
export * from "./ContentAttachments.vue?vue&type=script&lang=js"
import style0 from "./ContentAttachments.vue?vue&type=style&index=0&id=7ca511a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca511a6",
  null
  
)

export default component.exports